import { render, staticRenderFns } from "./ActionWebhook.vue?vue&type=template&id=5605397e&scoped=true&"
import script from "./ActionWebhook.vue?vue&type=script&lang=js&"
export * from "./ActionWebhook.vue?vue&type=script&lang=js&"
import style0 from "./ActionWebhook.vue?vue&type=style&index=0&id=5605397e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5605397e",
  null
  
)

export default component.exports